<script setup lang="ts">
import { cartBus } from '@/event/cartBus'
import { setRemoveProductMessage } from '@/happyTheme/event/modalBasket/messageAlertElementBasketHappy'
import { onMounted, ref } from 'vue'

const props = defineProps<{ index: number }>()

const counterBasket = ref(0)

function increment() {
    counterBasket.value++
    if (counterBasket.value > 1) {
        const countElement = counterBasket.value - 1
        const price = cartBus.value[props.index].total_price / countElement
        const priceTax = cartBus.value[props.index].price_tax / countElement

        cartBus.value[props.index].quantity = counterBasket.value
        cartBus.value[props.index].total_price = price * counterBasket.value
        cartBus.value[props.index].price_tax = priceTax * counterBasket.value
    }
}

function decrement() {
    if (counterBasket.value > 1) {
        const countElement = counterBasket.value
        counterBasket.value--

        const price = cartBus.value[props.index].total_price / countElement
        const priceTax = cartBus.value[props.index].price_tax / countElement

        cartBus.value[props.index].quantity = counterBasket.value
        cartBus.value[props.index].total_price = price * counterBasket.value
        cartBus.value[props.index].price_tax = priceTax * counterBasket.value
    } else if (counterBasket.value === 1) {
        const product = cartBus.value[props.index]
        setRemoveProductMessage(product)
    }
}

onMounted(() => {
    if (cartBus.value) {
        counterBasket.value = cartBus.value[props.index].quantity ?? 0
    }
})
</script>

<template>
    <section class="section-button-select-basket-happy">
        <div class="min-w-5 min-h-5">
            <button
                class="button-minus-basket-happy"
                @click.stop="decrement()"
                v-if="counterBasket >= 1"
            >
                <svg
                    class="svg-minus-happy"
                    viewBox="0 0 15 2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 1H14"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        </div>
        <p class="text-counter-option-value-happy">{{ counterBasket }}</p>

        <button class="button-plus-basket-happy" @click.stop="increment()">
            <svg
                class="svg-plus-happy"
                viewBox="0 0 17 17"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 8.5H16M8.5 1V16"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button>
    </section>
</template>

<style scoped>
.section-button-select-basket-happy {
    @apply flex items-center justify-between gap-2 min-w-16 max-w-24 h-full;
}

.button-minus-basket-happy {
    @apply flex items-center border border-button-yellow-happy-light bg-bg-happy-light rounded-[5px] p-1;
    @apply shadow-sm shadow-text-dark-happy-light;
    @apply happy-dark:shadow-bg-happy-light;
    @apply happy-urban-dark-red:border-urban-red happy-urban-dark-red:bg-urban-red happy-urban-dark-red:shadow-bg-happy-light;
    @apply happy-urban-light-red:border-urban-red happy-urban-light-red:bg-urban-red;
    @apply happy-orange-light:border-bg-orange happy-orange-light:bg-bg-orange;
    @apply happy-orange-dark:border-bg-orange happy-orange-dark:bg-bg-orange happy-orange-dark:shadow-bg-happy-light;
    @apply happy-fresh-mint:border-bg-mint happy-fresh-mint:bg-bg-mint;
    @apply happy-bee-light:border-bee-yellow happy-bee-light:bg-bee-yellow;
    @apply happy-bee-dark:border-bee-yellow happy-bee-dark:bg-bee-yellow happy-bee-dark:shadow-bg-happy-light;
    @apply happy-earth-stone:border-earth-card-dark happy-earth-stone:bg-earth-card-dark happy-earth-stone:shadow-bg-happy-light;
    @apply happy-scorched-earth:border-scorched-earth-yellow happy-scorched-earth:bg-scorched-earth-yellow happy-scorched-earth:shadow-urban-dark;
    @apply happy-sand-sky:bg-sand-blue happy-sand-sky:border-sand-blue;
    @apply happy-gray-sand:bg-gray-sand-gray-dark happy-gray-sand:border-gray-sand-gray-dark;
    @apply happy-purple-gradient:border-pink-dark happy-purple-gradient:bg-pink-dark happy-purple-gradient:shadow-bg-happy-light;
}

.svg-minus-happy {
    @apply w-3 h-3 stroke-text-dark-happy-light;
    @apply happy-urban-dark-red:stroke-bg-happy-light;
    @apply happy-urban-light-red:stroke-bg-happy-light;
    @apply happy-orange-light:stroke-bg-happy-light;
    @apply happy-orange-dark:stroke-bg-happy-light;
    @apply happy-fresh-mint:stroke-bg-happy-light;
    @apply happy-bee-light:stroke-urban-dark;
    @apply happy-bee-dark:stroke-urban-dark;
    @apply happy-earth-stone:stroke-bg-happy-light;
}

.text-counter-option-value-happy {
    @apply text-lg text-center w-6 font-semibold;
    @apply happy-light:text-text-dark-happy-light;
    @apply happy-dark:text-bg-happy-light;
}

.button-plus-basket-happy {
    @apply flex items-center border border-button-yellow-happy-light bg-button-yellow-happy-light p-1 rounded-[5px];
    @apply shadow-sm shadow-text-dark-happy-light;
    @apply happy-dark:shadow-bg-happy-light;
    @apply happy-urban-dark-red:border-urban-red happy-urban-dark-red:bg-urban-red happy-urban-dark-red:shadow-bg-happy-light;
    @apply happy-urban-light-red:border-urban-red happy-urban-light-red:bg-urban-red;
    @apply happy-orange-light:border-bg-orange happy-orange-light:bg-bg-orange;
    @apply happy-orange-dark:border-bg-orange happy-orange-dark:bg-bg-orange happy-orange-dark:shadow-bg-happy-light;
    @apply happy-fresh-mint:border-bg-mint happy-fresh-mint:bg-bg-mint happy-fresh-mint:shadow-urban-dark;
    @apply happy-bee-light:border-bee-yellow happy-bee-light:bg-bee-yellow;
    @apply happy-bee-dark:border-bee-yellow happy-bee-dark:bg-bee-yellow happy-bee-dark:shadow-bg-happy-light;
    @apply happy-earth-stone:border-earth-card-dark happy-earth-stone:bg-earth-card-dark happy-earth-stone:shadow-bg-happy-light;
    @apply happy-scorched-earth:border-scorched-earth-yellow happy-scorched-earth:bg-scorched-earth-yellow happy-scorched-earth:shadow-urban-dark;
    @apply happy-sand-sky:bg-sand-blue happy-sand-sky:border-sand-blue;
    @apply happy-gray-sand:bg-gray-sand-gray-dark happy-gray-sand:border-gray-sand-gray-dark;
    @apply happy-purple-gradient:border-pink-dark happy-purple-gradient:bg-pink-dark happy-purple-gradient:shadow-bg-happy-light;
}

.svg-plus-happy {
    @apply w-3 h-3 stroke-text-dark-happy-light;
    @apply happy-urban-dark-red:stroke-bg-happy-light;
    @apply happy-urban-light-red:stroke-bg-happy-light;
    @apply happy-orange-light:stroke-bg-happy-light;
    @apply happy-orange-dark:stroke-bg-happy-light;
    @apply happy-fresh-mint:stroke-bg-happy-light;
    @apply happy-bee-light:stroke-urban-dark;
    @apply happy-bee-dark:stroke-urban-dark;
    @apply happy-earth-stone:stroke-bg-happy-light;
}

.button-plus-basket-happy:active .svg-plus-happy,
.button-plus-basket-happy:focus .svg-plus-happy {
    @apply stroke-bg-happy-light;
    @apply happy-gray-sand:stroke-urban-dark;
}
.button-minus-basket-happy:active,
.button-plus-basket-happy:active,
.button-minus-basket-happy:focus,
.button-plus-basket-happy:focus {
    @apply bg-hover-yellow-happy border-bg-happy-light;
    @apply happy-light:border-hover-yellow-happy;
    @apply happy-urban-dark-red:bg-urban-red-dark;
    @apply happy-urban-light-red:bg-urban-red-dark;
    @apply happy-orange-light:bg-bg-orange-dark happy-orange-light:border-bg-orange-dark;
    @apply happy-orange-dark:bg-bg-orange-dark happy-orange-dark:border-bg-orange-dark;
    @apply happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:border-bg-mint-dark;
    @apply happy-bee-light:bg-bee-yellow-dark happy-bee-light:border-bee-yellow-dark;
    @apply happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:border-bg-happy-light;
    @apply happy-earth-stone:bg-earth-card happy-earth-stone:border-earth-card-dark;
    @apply happy-scorched-earth:bg-scorched-earth-red happy-scorched-earth:border-scorched-earth-red;
    @apply happy-sand-sky:bg-sand-blue-dark happy-sand-sky:border-sand-blue-dark;
    @apply happy-gray-sand:bg-gray-sand-gray-light happy-gray-sand:border-gray-sand-gray-dark;
    @apply happy-purple-gradient:bg-pink-light happy-purple-gradient:border-pink-dark;
}
.button-minus-basket-happy:active .svg-minus-happy,
.button-minus-basket-happy:focus .svg-minus-happy {
    @apply stroke-bg-happy-light;
    @apply happy-gray-sand:stroke-urban-dark;
}
@media (hover: hover) {
    .button-plus-basket-happy:hover,
    .button-minus-basket-happy:hover {
        @apply bg-hover-yellow-happy border-bg-happy-light;
        @apply happy-light:border-hover-yellow-happy;
        @apply happy-urban-dark-red:bg-urban-red-dark happy-urban-dark-red:border-urban-red-dark;
        @apply happy-urban-light-red:bg-urban-red-dark happy-urban-light-red:border-urban-red-dark;
        @apply happy-orange-light:bg-bg-orange-dark happy-orange-light:border-bg-orange-dark;
        @apply happy-orange-dark:bg-bg-orange-dark happy-orange-dark:border-bg-orange-dark;
        @apply happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:border-bg-mint-dark;
        @apply happy-bee-light:bg-bee-yellow-dark happy-bee-light:border-bee-yellow-dark;
        @apply happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:border-bg-happy-light;
        @apply happy-earth-stone:bg-earth-card happy-earth-stone:border-earth-card-dark;
        @apply happy-scorched-earth:bg-scorched-earth-red happy-scorched-earth:border-scorched-earth-red;
        @apply happy-sand-sky:bg-sand-blue-dark happy-sand-sky:border-sand-blue-dark;
        @apply happy-gray-sand:bg-gray-sand-gray-light happy-gray-sand:border-gray-sand-gray-dark;
        @apply happy-purple-gradient:bg-pink-light happy-purple-gradient:border-pink-dark;
    }
    .button-plus-basket-happy:hover .svg-plus-happy {
        @apply stroke-bg-happy-light;
        @apply happy-fresh-mint:stroke-bg-happy-light;
        @apply happy-gray-sand:stroke-urban-dark;
        @apply happy-purple-gradient:stroke-urban-dark;
    }
    .button-minus-basket-happy:hover .svg-minus-happy {
        @apply stroke-bg-happy-light;
        @apply happy-fresh-mint:stroke-bg-happy-light;
        @apply happy-bee-light:stroke-bg-happy-light;
        @apply happy-bee-dark:stroke-bg-happy-light;
        @apply happy-gray-sand:stroke-urban-dark;
        @apply happy-purple-gradient:stroke-urban-dark;
    }
}
</style>
